module.exports = "pegasus_template/assets/themelp1/tickets/102.png";